export const setPhoneNumberOtpResendCount = (count) => {
    localStorage.setItem("phoneNumberOtpResendCount", JSON.stringify(count));
}

export const getPhoneNumberOtpResendCount = () => {
    const phoneNumberOtpResendCount = JSON.parse(localStorage.getItem("phoneNumberOtpResendCount"));
    return phoneNumberOtpResendCount;
}

export const removePhoneNumberOtpResendCount = () => {
    localStorage.removeItem("phoneNumberOtpResendCount");
};